import { ReactElement } from 'react';

export function NudgeMessaging({
  variant,
}: Readonly<{ variant?: string }>): ReactElement {
  let message = 'Lifetime deal'; // variant 'a'
  if (variant === 'b') {
    message = 'Pay once, not monthly';
  } else if (variant === 'c') {
    message = 'One-time payment. Lifetime benefit.';
  }

  return (
    <div className="mb-1 w-fit rounded bg-dollar/25 p-2 text-center text-xs font-semibold text-midnight md:mb-2">
      <span>{message}</span>
    </div>
  );
}
